<template>
    <div class="CommPosFixed">
        <!-- :class="{Style2:Type=='org'}" -->
        <div class="AuditMol" >
             <!-- :class="{Style2:Type=='org'}" -->
            <div class="InfoHead">
                <div class="TableNum TableDis">项目信息 <span class="PosAbs" @click="InfoBlon=true">项目预览</span></div>
                <div class="DigItem">
                    <div class="DigItemWidTit MarRt10"><span class="Red">*</span>标题</div>
                    <el-input readonly class="Wid" size="medium" placeholder="请输入名称"
                        v-model="newData.record_name"></el-input>
                </div>
                <div class="DigItem" v-for="item in rowData.group" :key="item.id">
                    <div class="DigItemWidTit MarRt10">
                        <span class="Red" v-if="item.is_required">*</span>{{ item.field_label }}
                    </div>
                    <el-input readonly v-if="item.field_type == 'text'" class="Wid" size="medium"
                        :placeholder="item.placeholder" v-model="item.default_value"></el-input>
                    <el-input readonly v-if="item.field_type == 'textarea'" class="Wid" size="medium"
                        type="textarea" :rows="2" :placeholder="item.placeholder" v-model="item.default_value"></el-input>
                    <template v-if="item.field_type == 'select'">
                        <el-select disabled class="Wid" size="medium" v-model="item.default_value"
                            :placeholder="item.placeholder">
                            <el-option v-for="items in item.field_options" :key="items.label" :label="items.label"
                                :value="items.label"></el-option>
                        </el-select>
                    </template>
                    <template v-if="item.field_type == 'radio'">
                        <el-radio-group disabled v-model="item.default_value">
                            <el-radio v-for="items in item.field_options" :key="items.label"
                                :label="items.label">{{ items.label }}</el-radio>
                        </el-radio-group>
                    </template>
                    <template v-if="item.field_type == 'checkbox'">
                        <el-checkbox-group disabled size="medium" v-model="item.default_value">
                            <el-checkbox v-for="items in item.field_options" :label="items.label"
                                :key="items.label">{{ items.label }}</el-checkbox>
                        </el-checkbox-group>
                    </template>
                    <template v-if="item.field_type == 'date'">
                        <el-date-picker size="medium" class="Wid" readonly v-model="item.default_value"
                            type="date" :placeholder="item.placeholder"></el-date-picker>
                    </template>
                    <template v-if="item.field_type == 'file'">
                        <span class="FuJianPos">文件</span>
                        <el-tooltip effect="dark" content="查看文件" placement="top-start">
                            <i class="NavIcon el-icon-view" @click="LockUrl(item.default_value)"></i>
                        </el-tooltip>
                    </template>
                    <template v-if="item.field_type == 'img_text'">
                        <div class="Wid">
                            <div class="DisFlex MarTop" v-for="(items, is) in item.default_value" :key="is">
                                <div class="DisFlex" v-if="items.img_url">
                                    <el-image :preview-src-list="[$Tools.ServeUrl()+items.img_url]" class="ImgPos" :src="$Tools.ServeUrl()+items.img_url" fit="contain"></el-image>
                                </div>
                                <el-input type="textarea" :rows="2" readonly size="medium" :placeholder="'图片'+(is+1)+'相关描述'" v-model="items.img_desc"></el-input>
                            </div>
                        </div>
                    </template>
                    <template v-if="item.field_type == 'area'">
                        <el-cascader disabled class="Wid" :options="CityList" v-model="item.default_value" size="medium" :placeholder="item.placeholder"
                        :props="{value:'name',label: 'name',children: 'children'}"
                        clearable filterable></el-cascader> 
                    </template>
                </div>
                <div class="DigItem" v-if="rowData.gl_file.length>0">
                    <div class="DigItemWidTit MarRt10">添加附件</div>
                    <div class="DisFlex">
                        <div class="DisFlex">
                            <div class="FuJianPos" v-for="(item, i) in rowData.gl_file" :key="item" @click="LockUrl(item)">
                                文件{{ i + 1 }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <!-- :class="{Style2:Type=='org'}" -->
            <div class="PingShenHead">
                <div class="DigTable">
                    <div class="DigTableTop TableBg">
                        <div class="DigTableBor Wid30 TablePad">评价指标</div>
                        <div class="DigTableBor Wid70 TablePad">评定打分</div>
                    </div>
                    <div class="DigTableHead" v-for="item in NewItemList" :key="item.id">
                        <div class="DigTableDis">
                            <div class="ItemDis DigTableBor Wid30">
                                <div class="ItemTit">{{item.indicator}}</div>
                                <div class="ItemFuTit">
                                    <div>{{item.description}}</div>
                                    <!-- <div class="ItemQz">权重：{{item.weight}}</div> -->
                                </div>
                            </div>
                            <div class="DigTableBor Wid70">
                                <div class="ItemRadio">
                                    <!-- <label class="Radio" :style="{'width':(100/(item.score+1))+'%'}"
                                        v-for="(i,num) in item.score+1">
                                        <div class="RadioCer"><input type="radio" :name="'Radio'+item.id" :value="num"
                                                v-model="item.rating">{{num}}</div>
                                    </label> -->
                                    <div class="ItemRadioFlex" v-if="Type!='org'">
                                        <el-input
                                        class="ItemRadioVal"
                                        :placeholder="'请输入分值,最小分数为0最大分数为'+item.score" 
                                        type="number"
                                        size="small"
                                        :min="0"
                                        :max="item.score"
                                        step="1"
                                        v-model="item.rating" 
                                        @input="(val) => ChangeVal(item, val)"
                                        @blur="() => BlurVal(item)"></el-input>
                                        <span>最多输入{{item.score}}分</span>
                                    </div>
                                    <div class="ItemRadioFlex" v-else>
                                        <el-select class="ItemRadioVal" size="small" v-model="item.rating" clearable :placeholder="'请选择分值,最小分数为0最大分数为'+item.score" >
                                            <el-option  v-for="(i,num) in item.score+1" :key="'Radio'+num" :label="num" :value="num"></el-option>
                                        </el-select>
                                        <span>满分{{item.score}}分</span>
                                    </div>
                                </div>
                                <div class="ItemRadioMsg">
                                    <!-- <div class="ItemRadioMsgDom" v-for="i in item.text_content"
                                        :style="{'width':(100/(item.score+1)*((i.maxScore-i.minScore)+1))+'%'}">
                                        <div class="RadioCer"><span>{{i.tipText}}</span></div>
                                    </div> -->
                                    <div class="ItemRadioFlex">{{item.text_content}}</div>
                                </div>
                            </div>
                        </div>
                        <template>
                            <div class="ItemMsg" v-if="item.gl_yj">形式审查意见：{{item.gl_yj}}</div>
                            <div class="ItemMsg" v-if="item.rating!=='' && item.rating!=item.score && rowData.review_reason_required">
                                <el-input class="Wid ColorRed" placeholder="请输入不是满分原因" v-model="item.opinion" > </el-input>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="DigItem">
                    <span class="Red" v-if="Type=='fund'">*</span>
                    <el-input class="Wid" type="textarea" :rows="2" placeholder="请输入综合意见及建议" v-model="Remark"></el-input>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="footerNum">满分：{{GetTotalNum}} 当前得分：<span class="Red">{{GetScoreNum}}</span> <span class="TableMsg" v-if="rowData.miaoshu">({{rowData.miaoshu}})</span></div>
            <div class="footerMsg" v-if="rowData.sy_edit_count!='-1'">当前可修改次数为：{{rowData.sy_edit_count}}次</div>
            <div>
                <el-button v-throttle size="small" @click="CloseDig">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="info" @click="SucData(0)" v-if="rowData.sy_edit_count=='-1'">保存</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucData(1)" v-if="rowData.sy_edit_count>0 ||rowData.sy_edit_count=='-1' ">提交</el-button>
            </div>
        </div>
        <FieldMol :visible="InfoBlon" :BaoCun="false" Type="Lock" :rowData="rowData" :newData="newData" @cancel="InfoBlon=false"/>
        <el-dialog title="签名" :visible.sync="QRcodeBlon" width="20%" :modal-append-to-body="false">
            <div class="QRcodeHead">
                <img class="QRcodeImg" :src="QRcode" alt="" />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-throttle size="small" @click="QRcodeBlon = false">取消签名</el-button>
                <el-button v-throttle size="small" type="primary" @click="SucQRcode">我已签名</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "",
        props: {
            itemList: {
                type: Array,
                default: () => []
            },
            itemList: {
                type: Array,
                default: () => []
            },
            // 综合意见 - 父组件传入
            auditRemark: {
                type: String,
                default: ""
            },
            ZuZhang: {
                type: Number,
                default: 0
            },
            rowData: {
                type: Object,
                default: () => ({
                    group: [],
                    gl_file: []
                }),
            },
            // 基础数据 包含id和标题
            newData: {
                type: Object,
                default: () => ({
                    id: "",
                    record_name: ""
                }),
            },
            Type: {
                type: String,
                default: "",
            },
        },
        data() {
            return {
                Remark: this.auditRemark,
                NewItemList: JSON.parse(JSON.stringify(this.itemList)),
                CityList:JSON.parse(this.$Tools.localData("City")),
                InfoBlon:false,
                QRcodeBlon:false,
                QRcode:""
            };
        },
        mounted() {
            if(this.Type=='fund'){
                this.MsgFund()
            }
        },
        watch: {
            auditRemark(newVal) {
              this.Remark = newVal;
            },
            // ✅ 监听父组件itemList变化，同步更新本地数组
            itemList(newVal) {
              this.NewItemList = JSON.parse(JSON.stringify(newVal));
            }
        },
        computed: {
            // 实时计算总评分，保留原有计算逻辑
            GetScoreNum() {
                let total = 0;
                if (this.NewItemList && this.NewItemList.length > 0) {
                    this.NewItemList.forEach(i => {
                        const rating = Number(i.rating) || 0;
                        const weight = Number(i.weight) || 0;
                        total += weight * rating;
                    });
                }
                return total;
            },
            GetTotalNum() {
                let total = 0;
                if (this.NewItemList && this.NewItemList.length > 0) {
                    this.NewItemList.forEach(i => {
                        const num = Number(i.score) || 0;
                        total += num;
                    });
                }
                return total;
            },
        },
        methods: {
            CloseDig() {
                this.$emit("cancel");
            },
            SucData(n) {
                if(n==1){
                    // this.ChangeData(this.NewItemList,n,this.Remark)
                    this.SucQRcode()
                }else{
                    this.$emit("submit",this.NewItemList,n,this.Remark);
                }
            },
            ChangeVal(item, val) {
              if (val === null || val === undefined || val === '') {item.rating = '';return;}
              const pureNum = val.toString().replace(/[^0-9]/g, '');
              let num = pureNum ? Number(pureNum) : 0;
              const maxVal = item.score || 0;
              if (num > maxVal) {num = maxVal;}
              item.rating = num;
            },
            BlurVal(item) {
              let num = Number(item.rating);
              if (isNaN(num)) {num = 0;}
              const minVal = 0;
              const maxVal = item.score || 0;
              num = Math.max(minVal, Math.min(maxVal, num));
              item.rating = Math.floor(num);
            },
            ChangeData(data,n,remark){
                var Arr = [];
                data.forEach(i=>{
                    Arr.push({
                        id:i.score_rule_id || i.id,
                        rating:i.rating,
                        opinion:i.opinion,
                        indicator:i.indicator,
                    })
                });
                var url = this.rowData.sq_status == 3?'/api/expert_portal/online/grade':'/api/expert_portal/final/grade'
                this.$post(url,{
                    id:this.rowData.id,
                    ruid:this.rowData.ruid,
                    opinion:remark,
                    data:Arr,
                    is_tj:n,
                    is_yanzheng:1,
                }).then(res=>{
                    this.$confirm('确认是否提交?', '提示', {
                    	type: 'warning'
                    }).then(() => {
                        this.$post("/api/expert_portal/final/fqrcodes", {
                            "id":this.rowData.id,
                            "ruid":this.rowData.ruid,
                        }).then(res => {
                            if (res) {
                                this.QRcode = res.data.base64;
                                this.QRcodeBlon = true;
                            }
                        })
                    })
                })
            },
            // 查看文件链接 - 触发父组件的查看链接事件
            LockUrl(url){
                window.open(this.$Tools.ServeUrl()+url)
            },
            SucQRcode(){
                this.$emit("submit",this.NewItemList,1,this.Remark);
            },
            MsgFund(){
                this.$alert(`
                <p>1）评审的合格分数为60分，60分以上方可建议通过，分数需要和最终建议保持一致；</p>
                <p>2）2）请务必写明“建议通过”或“建议不通过”，及详细的评审意见和建议。</p>
                `, '尊敬的评审专家您好，请注意', {
                  dangerouslyUseHTMLString: true
                });
                
            }
        }
    };
</script>

<style scoped>
    .AuditMol{
        padding: 20px 20px 130px;
    }
    .AuditMol.Style2{
        display: flex;
        gap: 20px;
    }
    .InfoHead{
        width:100%;
        max-height: 600px;
        overflow-y: auto;
        padding-bottom: 10px;
    }
    .InfoHead.Style2{
        width:40%;
        max-height: 750px;
        overflow-y: auto;
    }
    .DisFlex {
        display: flex;
        align-items: center;
    }
    .ImgPos {
        width: 70px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }
    .FuJianPos {
        padding: 3px 5px;
        border: 1px solid #ddd;
        border-radius: 5px;
        cursor: pointer;
        font-size: 14px;
    }
    .PingShenHead{
        border-top: 3px solid #ddd;
        padding-top: 10px;
        width:100%;
        max-height: 1000px;
        overflow-y: auto;
    }
    .PingShenHead.Style2{
        flex: 1;
        border-top: 0;
        padding-top: 0;
        max-height: 750px;
        overflow-y: auto;
    }
    .TableBg {
        background: #dcdcdc;
    }

    .TablePad {
        padding: 10px 0;
        font-weight: 700;
    }
    .Wid30 {
        width: 35%;
    }
    .Wid70 {
        width: 65%;
    }
    .TableNum {
        padding-bottom: 10px;
        font-weight: 700;
        position: relative;
    }
    .TableMsg{
        padding-left: 10px;
        color: #555;
    }
    .TableDis{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .PosAbs{
        /* position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0,-50%); */
        cursor: pointer;
        font-size: 14px;
    }
    .DigTable {
        border: 1px solid #028b8b;
        margin-bottom: 10px;
    }
    .DigTableTop {
        display: flex;
        border-bottom: 1px solid #028b8b;
    }
    .DigTableHead {
        border-bottom: 1px solid #028b8b;
    }
    .DigTableDis {
        display: flex;
    }
    .ItemDis {
        display: flex;
        align-items: center;
    }
    .DigTableBor {
        text-align: center;
        border-right: 1px solid #028b8b;
    }
    .DigTableBor:last-child {
        border: 0;
    }
    .ItemTit {
        width: 130px;
        font-weight: 500;
        font-size: 18px;
        padding: 5px;
    }
    .ItemFuTit {
        flex: 1;
        padding: 5px;
        min-height: 55px;
        border-left: 1px solid #028b8b;
        text-align: left;
    }
    .ItemQz {
        padding-top: 5px;
    }
    .ItemRadio {
        height: 50%;
    }
    .ItemRadioFlex{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .ItemRadioVal{
        width: 50%;
    }
    .ItemRadio .Radio {
        height: 100%;
        display: inline-block;
        position: relative;
    }
    .RadioCer {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }
    .RadioCer input {
        margin-top: 0;
    }
    .RadioCer span {
        font-size: 12px;
    }
    .ItemRadio .Radio::after {
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        height: 100%;
        border-right: 1px solid #028b8b;
    }
    .ItemRadioMsg {
        height: 50%;
        border-top: 1px solid #028b8b;
    }
    .ItemRadioMsg .ItemRadioMsgDom {
        height: 100%;
        display: inline-block;
        position: relative;
    }
    .ItemRadioMsg .ItemRadioMsgDom::after {
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        height: 100%;
        border-right: 1px solid #028b8b;
    }
    .ItemMsg {
        padding: 5px;
        border-top: 1px solid #028b8b;
    }
    .ColorRed{
        border: 1px solid red;
    }
    .ItemRadio .Radio:last-child::after,
    .ItemRadioMsg .ItemRadioMsgDom:last-child::after,
    .DigTableHead:last-child {
        border: 0;
    }
    .DigItem {
        width: 100%;
    }
    .Wid {
        width: 100%;
    }
    .footer{
        border-top: 1px solid #ddd;
        text-align: center;
        padding: 20px 0;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: #fff;
    }
    .footerNum{
        padding-bottom: 5px;
    }
    .footerMsg{
        padding-bottom: 5px;
        font-size: 12px;
    }
    .QRcodeHead{
        text-align: center;
    }
    .QRcodeImg{
        width: 200px;
        height: 200px;
        border-radius: 5px;
    }
</style>